// Must match: Src\MainSolution\Airsweb.Common.Constants\FileTypes.cs
export enum FileTypes {
    CSV,
    Image,
    PDF,
    Presentation,
    Spreadsheet,
    TextDocument
}
